import { ChevronDown, ChevronUp, Info } from 'lucide-react'
import { useState } from 'react'
import { useROIStore } from '../store'
import { ROI_METADATA } from '../data'

export function BenchmarkReference() {
  const [isExpanded, setIsExpanded] = useState(false)
  const { regions } = useROIStore()

  // Collect all unique products from all regions
  const allProducts = new Map<string, { description: string; passRate: number; totalVerifications: number }>()

  regions.forEach((region) => {
    region.stack.forEach((item) => {
      if (!allProducts.has(item.profile)) {
        allProducts.set(item.profile, {
          description: item.description,
          passRate: item.passRate,
          totalVerifications: 0, // We don't have this in stack items
        })
      }
    })
  })

  const productList = Array.from(allProducts.values())

  if (productList.length === 0) return null

  return (
    <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg overflow-hidden">
      {/* Header - Click to expand */}
      <button
        className="w-full flex items-center justify-between p-3 text-left hover:bg-[var(--bg-tertiary)]/50 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2 text-xs text-[var(--text-secondary)]">
          <Info size={14} />
          <span>Benchmark Reference</span>
        </div>
        {isExpanded ? <ChevronUp size={16} className="text-[var(--text-muted)]" /> : <ChevronDown size={16} className="text-[var(--text-muted)]" />}
      </button>

      {/* Content */}
      {isExpanded && (
        <div className="border-t border-[var(--border-color)] p-3 space-y-3">
          {/* Note */}
          <p className="text-[11px] text-[var(--text-muted)] leading-relaxed">
            FrankieOne pass rates based on 4M+ verifications since {ROI_METADATA.dateFilter}.
            Actual results may vary based on customer demographics and data quality.
          </p>

          {/* Selected Products */}
          <div className="space-y-1">
            <div className="text-[10px] text-[var(--text-muted)] uppercase tracking-wide mb-2">
              Selected Products
            </div>
            {productList.map((product, index) => (
              <div key={index} className="flex items-center justify-between text-xs">
                <span className="text-[var(--text-primary)]">{product.description}</span>
                <span className="text-primary font-medium">{product.passRate}%</span>
              </div>
            ))}
          </div>

          {/* Data info */}
          <div className="text-[10px] text-gray-600 pt-2 border-t border-[var(--border-color)]">
            Last updated: {ROI_METADATA.lastUpdated}
          </div>
        </div>
      )}
    </div>
  )
}
